
import axios from 'axios';


const WoocommerceAPI = {









async addAjaxToCart(base_url, ajaxurl, formdata) {
 // console.log("###Ajax to cart###");






//const url = `${base_url}/?wc-ajax=add_to_cart`;
const url = `${base_url}/?wc-ajax=ips_ajax_addtocart`;

  let responseaddto = [];

try {
 // console.log("## Hinzufügen zum Warenkorb ##");

  //const responseaddto = await axios.post(url, data);
  responseaddto = await axios.post(url, formdata);

 // console.log("Antwort vom Server:", responseaddto.data);
  // Verarbeite die Antwort hier
} catch (error) {
  console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
}

if (responseaddto.status === 200) {
  const responseData = responseaddto.data;
 

  return responseData;
} else {
  throw new Error('Network response was not ok.');
}




},



/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* **********************   Füge ein Produkt zum ersten mal im Warenkorb hinzu   ****************************/


  async addToCart(base_url, itemId, quantity, producttyp, keyID, selectedOptions = null, formData = null, orderbumpsettings = null) {
    //console.log("Füge Product der Cart hinzu - addToCard Ajax call - ips_addproduct_cart:");
    //console.log("Itemid: ",itemId);

  // Überprüfung, ob discountprice null ist und setzen auf 0, falls erforderlich
 
  const currentTime = new Date();
  const n = currentTime.getTime();
  
  
    //console.log("Key-ID: ",keyID);
    //console.log("FOrderbumbsettings send: ",orderbumpsettings);
    //console.log("FormData send: ",formData);
   
    const url = `${base_url}/?wc-ajax=ips_addproduct_cart&nocache=${n}`;
    ///const url = `${base_url}/?wc-ajax=ips_addproduct_cart`;


  // Überprüfung, ob formData null oder ein leeres Objekt ist
    let formObject = {};
    if (formData && typeof formData.forEach === 'function') {
        // Konvertiere FormData in ein einfaches Objekt, wenn es nicht null ist
        formData.forEach((value, key) => {
            formObject[key] = value;
        });
    }

    const data = {
      product_id: itemId,
      ipsquantity: quantity,
      producttyp: producttyp,
      cart_key: keyID,
      selectedOptions: selectedOptions,
      //formdata: formData,
      formdata: formObject,
      orderbumpsettings: orderbumpsettings
    };

    try {
    //  console.log("##Füge hinzu A##");
  

      
      const responseaddto = await axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    
    
    //  console.log("##Füge hinzu B##");
      if (responseaddto.status === 200) {
        const responseData = responseaddto.data;
        //console.log('Response Data - Add-to-Cart:', responseData);
        
        
          // Rufe die aktualisierten Fragmente ab, um sicherzustellen, dass der Warenkorb-Status im Frontend sofort reflektiert wird
          try {
            //const fragmentsResponse = await axios.post(`${base_url}/?wc-ajax=ips_basic_refreshed_fragments`);
            const fragmentsResponse = await axios.post(`${base_url}/?wc-ajax=ips_basic_refreshed_fragments&nocache=${n}`);
            if (fragmentsResponse.status === 200 && fragmentsResponse.data.success) {
              // Aktualisiere die HTML-Fragmente im Frontend
              const fragments = fragmentsResponse.data.data; // Holen Sie sich die Fragmente aus der Antwort
              //console.log("The basic fragments: ",fragments);
            /*  Object.keys(fragments).forEach((selector) => {
                const element = document.querySelector(selector);
                if (element) {
                  element.innerHTML = fragments[selector];
                }
              });*/
            }
          } catch (error) {
            console.error("Fehler beim Abrufen der aktualisierten Fragmente:", error);
          }
                
        
        // Handle the response data accordingly



        return responseData;
      } else {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error('There was a problem with the Axios operation:', error);
      throw error;
    }




  },
  



/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* **********************     Lösche ein Produkt komplett aus der Cart      *********************************/

async removeFromCart(base_url, itemKey, basicauth) {
  const authHeader = 'Basic ' + btoa(basicauth);
 // console.log("Lösche Produkt aus Cart");
 // console.log("Zu löschende Product-ID: " + itemKey);
  
  try {
   // const nonceResponse = await this.getNonce(); 
 //   console.log("THE NONCE 1: " + nonceResponse);
    //const nonce = nonceResponse ? nonceResponse : '';
   // console.log("THE NONCE 2: " + nonce);


    const response2 = await fetch(`${base_url}/wp-json/wc/store/cart/items`);
    const nonce = response2.headers.get('nonce');
    const cartToken = response2.headers.get('cart-token');
   // console.log("THE Cart Token: " + cartToken);
   // console.log("THE Nonce: " + nonce);


    const config = {
      headers: {
        'Authorization': authHeader,
        'X-WC-Store-API-Nonce': nonce,
        'Cart-Token': cartToken,
        'Content-Type': 'application/json',
      },
      data: {
        id: itemKey, // Oder die notwendigen Daten für die Anfrage
      },
    };

    const response = await axios.delete(`${base_url}/wp-json/wc/store/cart/items/${itemKey}`, config);

  //  console.log(`Removed product with ID ${itemKey} from cart0`);
    return response.data; // Oder entsprechende Verarbeitung der Antwort
  } catch (error) {
    console.error(`Error removing product ${itemKey} from cart0:`, error);
    throw error;
  }
},



async ajax_removeFromCart(base_url, itemKey) {
 
//  console.log("Lösche Produkt aus Cart (AJAX)");
//  console.log("Zu löschende Product-ID: " + itemKey);

const currentTime = new Date();
const n = currentTime.getTime();
const url = `${base_url}/?wc-ajax=ips_deleteproduct_cart&nocache=${n}`;
//const url = `${base_url}/?wc-ajax=ips_deleteproduct_cart`;
  
const data = new URLSearchParams({
    itemKey: itemKey,
 
  });

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.status === 200) {
      const responseData = response.data;
   //   console.log('Response Data delete ajax:', responseData);
      // Handle the response data accordingly
      return responseData;
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('There was a problem with the Axios operation:', error);
    throw error;
  }



},




/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* **********************   Update der  Anzahl/Menge von einem Produkt im Warenkorb über WC-AJAX  ***********/


async ipsajax_updateCartItemQuantity(base_url, itemId, keyID, quantity, variation = false) {

  const currentTime = new Date();
  const n = currentTime.getTime();
  const url = `${base_url}/?wc-ajax=ips_increase_cart&nocache=${n}`;
  //const url = `${base_url}/?wc-ajax=ips_increase_cart`;
  const data = new URLSearchParams({
    product_id: itemId,
    cart_key: keyID,
    ipsquantity: quantity,
  });
 // console.log("UPDATE CART ITEM");

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.status === 200) {
      const responseData = response.data;
    //  console.log('Response Data up/down:', responseData);
      // Handle the response data accordingly
      return responseData;
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('There was a problem with the Axios operation:', error);
    throw error;
  }
},





/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* ****************************   Get all OrderBumps Settings über WC-AJAX  *********************************/


async ipsajax_fetchOrderbumps(base_url) {
  const url = `${base_url}/?wc-ajax=ips_getorderbumps`;
  const data = new URLSearchParams({
    product_id: 123,
 
  });
 // console.log("FETCH ORDERBUMPS");

  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.status === 200) {
      const responseData = response.data;
    //  console.log('Response Data - Orderbumps:', responseData);
      // Handle the response data accordingly
      return responseData;
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('There was a problem with the Axios operation:', error);
    throw error;
  }
},






/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* **************************   Lade alle Notices vom Server  über WC-AJAX  *********************************/


async ipsajax_getNotices(base_url) {
  const url = `${base_url}/?wc-ajax=ips_get_notices`;
  const data = new URLSearchParams({
    product_id: 123,
  });
//console.log("FETCH NOTICES");
  try {
    const response = await axios.post(url, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    if (response.status === 200) {
      const responseData = response.data;
     // console.log('Response Data - Notices:', responseData);
      // Handle the response data accordingly
      return responseData.data;
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('There was a problem with the Axios operation:', error);
    throw error;
  }
},






/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* **************************   IPS Endpoint Orderbumps Popup Variation     *********************************/


async ips_orderbumps_variation(base_url, product_id) {
//console.log("API ips_orderbumps_variation");
  const apiURL = `${base_url}/wp-json/woo-order-cart/v1/data_orderbumps_variation`;

  const data = new URLSearchParams({
    product_id: product_id,
  });

  try {
    
    const response = await axios.post(apiURL, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });

    // || -- || -- || -- || -- || -- || -- || -- || -- || -- ||

    if (response.status === 200) {
      const responseData = response.data;
    //  console.log('Response Data - Orderbumps Variations:', responseData);
      // Handle the response data accordingly
      return responseData;
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('There was a problem with the Axios operation:', error);
    throw error;
  }
},



/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* **************************   IPS Endpoint Orderbumps Variation IDs     *********************************/


async ips_getvariationIds(base_url, product_id) {
  //console.log("API get_variationIds");
    const apiURL = `${base_url}/wp-json/woo-order-cart/v1/data_orderbumps_variationids`;
  
    const data = new URLSearchParams({
      product_id: product_id,
    });
  
    try {
      
      const response = await axios.post(apiURL, data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
  
      // || -- || -- || -- || -- || -- || -- || -- || -- || -- ||
  
      if (response.status === 200) {
        const responseData = response.data;
       // console.log('Response Data - Orderbumps Variation IDs:', responseData);
        // Handle the response data accordingly
        return responseData;
      } else {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error('There was a problem with the Axios operation:', error);
      throw error;
    }
  },
  


/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* ********************************      getServerCart       ************************************************/


async getServerCart(base_url) {
  const url = `${base_url}/?wc-ajax=ips_get_server_cart`;
  try {
    const response = await axios.post(url, null, {
      headers: {
        //'Content-Type': 'application/x-www-form-urlencoded',
        'Content-Type': 'application/json',
      },
    });
    if (response.status === 200) {
      // Je nach Rückgabe deines PHP-Callbacks: 
      // wp_send_json_success( array( 'cartItems' => $cart_items ) );
      //console.log("Response: ",response)
      //console.log("Response single: ",response.data)
      //console.log("Response data.data: ",response.data.data)
      return response.data.data || response.data;
    } else {
      throw new Error('Network response was not ok.');
    }
  } catch (error) {
    console.error('Fehler beim Abrufen des Server-Warenkorbs:', error);
    throw error;
  }
},


/* **<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**<>**/
/* ********************************   refreshCartFragments   ************************************************/


async refreshCartFragments(base_url) {
   
    const url = `${base_url}/?wc-ajax=ips_block_refresh_fragments`;



    const data = {
      senddata: "",
    };

    try {
      
  

      
      const responsefragment = await axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    
    
      if (responsefragment.status === 200) {
        const responseData = responsefragment.data;
    
        return responseData;
      } else {
        throw new Error('Network response was not ok.');
      }
    } catch (error) {
      console.error('There was a problem with the Axios operation:', error);
      throw error;
    }




  },
  







  // Weitere Funktionen für API-Aufrufe hier hinzufügen...
};





export default WoocommerceAPI;